import React from 'react'

const FlatList = ({ data, renderItem }) => {
  return (
    <>
      {data?data.map((item, index) => renderItem(item, index)) : null}
    </>
  );
};

export default FlatList